/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2025.11.5",
    versionName: "0.2.0-nightly.2025.11.5",
    versionChannel: "nightly",
    buildDate: "2025-11-05T00:07:57.995Z",
    commitHash: "e31af970e0df9196b3e2cab87ca4de334fd0ce2e",
};
